/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'onboarding-profile': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 21',
    data: '<g fill-rule="evenodd" clip-rule="evenodd"><path pid="0" d="M6.3 15.6H4.8c-2.3 0-4.2 2-4.2 4.5 0 .2.2.4.4.4h9.3c.2 0 .4-.2.4-.4-.1-2.5-2-4.5-4.4-4.5zm-4.5 3.9c.2-1.6 1.5-2.9 3.1-2.9h1.4c1.6 0 2.9 1.3 3.1 2.9H1.8zM15.1 12.2c.3 0 .6.3.6.6s-.3.6-.6.6h-4.4c-.3 0-.6-.3-.6-.6s.3-.6.6-.6h4.4zM5.7 8.2C4.2 8.2 3 9.5 3 11.1S4.2 14 5.7 14c1.5 0 2.7-1.3 2.7-2.9S7.2 8.2 5.7 8.2zm0 4.6c-.9 0-1.6-.8-1.6-1.7 0-1 .7-1.7 1.6-1.7.9 0 1.6.8 1.6 1.7 0 .9-.7 1.7-1.6 1.7zM15.1 8.2c.3 0 .6.3.6.6s-.3.6-.6.6H9.8c-.3 0-.6-.3-.6-.6s.3-.6.6-.6h5.3z"/><path pid="1" d="M17.4 20.5c1.1 0 2.1-.9 2.2-2V2.7c0-1.1-.9-2.1-2-2.2H6.2c-1.1 0-2.1.8-2.2 2V6.3c0 .4.3.7.7.7.3 0 .6-.2.6-.5V2.8c0-.4.3-.8.7-.9h11.3c.4 0 .8.3.9.7v15.6c0 .4-.3.8-.7.9h-4.3c-.4 0-.7.3-.7.7 0 .3.2.6.5.6H17.4z"/></g>'
  }
})
